import { render } from "./StoryCommentsOverlay.vue.js?vue&type=template&id=7ba2aef6!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentsOverlay.vue?vue&type=template&id=7ba2aef6"
import script from "./StoryCommentsOverlay.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentsOverlay.vue?vue&type=script&lang=js"
export * from "./StoryCommentsOverlay.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentsOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/story-comments/StoryCommentsOverlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ba2aef6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ba2aef6', __exports__)) {
    api.reload('7ba2aef6', __exports__)
  }
  
  module.hot.accept("./StoryCommentsOverlay.vue.js?vue&type=template&id=7ba2aef6!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryCommentsOverlay.vue?vue&type=template&id=7ba2aef6", () => {
    api.rerender('7ba2aef6', render)
  })

}


export default __exports__